export { AnchorNode } from './AnchorNode';
export { findClosestAnchorNode } from './findClosestAnchorNode';
export { findClosestDocumentContentNode } from './findClosestDocumentContentNode';
export { getAnchorFromDocument } from './getAnchorFromDocument';
export { resolveAnchorPath } from './resolveAnchorPath';



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/anchor/index.tsx